import { useParams } from 'react-router-dom';
import { ResultDispatch } from '../results/Results';
import Block, { TitleBlock } from '../ui/Block';
import { PageContainer } from '../ui/Container';
import useReport from './context/useReport';

const ReportProjectResults = () => {
  const { reportId, projectId } = useParams();
  const { report } = useReport(reportId);

  if (!report) {
    return null;
  }

  const project = report.projects.find(
    (project) => project._id.toString() === projectId,
  );

  if (!project) {
    return null;
  }

  return (
    <PageContainer>
      <TitleBlock background="var(--reports-bg)">
        <h3>{report.name}</h3>
        <h4>{project.name}</h4>
        <p>Découvrez votre rapport d'impact ci-dessous</p>
      </TitleBlock>
      <Block>
        {project.results.map((result, index) => (
          <ResultDispatch result={result} key={index} model={project?.model} />
        ))}
      </Block>
    </PageContainer>
  );
};

export default ReportProjectResults;
